import axios from "axios";
export const state = {
    vehicles: [],
    expenses: [],
    expense_report: [],
    save_status: false,
    filter_status: false,
};
export const getters = {
    Vehicles: state => state.vehicles.data,
    VehicleExpenses: state => state.expenses.data,
    VehicleExpensesReport: state => state.expense_report.data,
    SaveStatus: state => state.save_status,
    FilterStatus: state => state.filter_status,
};

export const mutations = {
    SET_VEHICLES(state, newValue) {
        state.vehicles = newValue
    },
    SET_EXPENSES(state, newValue) {
        state.expenses = newValue
    },
    SET_EXPENSES_REPORT(state, newValue) {
        state.expense_report = newValue
    },
    SET_VEHICLE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },

};

export const actions = {
    // add new vehicle
    addVehicle({ commit, dispatch }, payload) {
        commit('SET_VEHICLE_STATUS', true);
        axios.post('vehicles', payload).then(() => {
            dispatch('fetchVehicles');
            let message = { 'msg': "Vehicle  added successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_VEHICLE_STATUS', false);
        }).catch(() => {
            commit('SET_VEHICLE_STATUS', false)
            let message = { 'msg': "Error Adding Vehicle" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Vehicle
    editVehicle({ commit, dispatch }, payload) {
        commit('SET_VEHICLE_STATUS', true);
        axios.put(`vehicles/${payload.id}`, payload).then(() => {
            dispatch('fetchVehicles');
            let message = { 'msg': "Vehicle updated successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_VEHICLE_STATUS', false);
        }).catch(() => {
            commit('SET_VEHICLE_STATUS', false)
            let message = { 'msg': "Error updating Vehicle" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete Vehicle
    deleteVehicle({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_VEHICLE_STATUS', true);
        axios.delete(`vehicles/${payload.id}`).then(() => {
            dispatch('fetchVehicles');
            let message = { 'msg': "Vehicle deleted successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_VEHICLE_STATUS', false);
        }).catch(() => {
            commit('SET_VEHICLE_STATUS', false)
            let message = { 'msg': "Error deleting Vehicle" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add Vehicle Expense
    recordExpense({ commit, dispatch }, payload) {
        commit('SET_VEHICLE_STATUS', true);
        axios.post('vehicle_expenses', payload).then(() => {
            dispatch('fetchExpenses');
            let message = { 'msg': "Vehicle Expense added successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_VEHICLE_STATUS', false);
        }).catch(() => {
            commit('SET_VEHICLE_STATUS', false)
            let message = { 'msg': "Error Adding Vehicle Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit expense
    editExpenses({ commit, dispatch }, payload) {
        commit('SET_VEHICLE_STATUS', true);
        axios.put(`vehicle_expenses/${payload.id}`, payload).then(() => {
            dispatch('fetchExpenses');
            let message = { 'msg': "Vehicle Expense updated successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_VEHICLE_STATUS', false);
        }).catch(() => {
            commit('SET_VEHICLE_STATUS', false)
            let message = { 'msg': "Error updating Vehicle Expense" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete expense 
    deleteExpense({ commit, dispatch }, payload) {
        commit('SET_VEHICLE_STATUS', true);
        axios.delete(`vehicle_expenses/${payload.id}`).then(() => {
            dispatch('fetchExpenses');
            let message = { 'msg': "Vehicle Expenditure deleted successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_VEHICLE_STATUS', false);
        }).catch(() => {
            commit('SET_VEHICLE_STATUS', false)
            let message = { 'msg': "Error Deleting Vehicle Expenditure" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchVehicles({ commit }) {
        axios.get('vehicles').then(ec_res => {
            commit('SET_VEHICLES', ec_res.data)
        })
    },
    fetchExpenses({ commit }) {
        axios.get('vehicle_expenses').then(e_res => {
            commit('SET_EXPENSES', e_res.data)
        })
    },

    fetchExpensesReport({ commit }, payload) {
        commit('SET_FILTER_STATUS', true);
        axios.post('vehicle_expenses_report', payload).then(e_res => {
            commit('SET_EXPENSES_REPORT', e_res.data);
            commit('SET_FILTER_STATUS', false);

        })
    },


};